module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<button kendoButton [primary]=\"config.primary\" [iconClass]=\"config.icon\">{{ config.contentKey | translate }}</button>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/button/button.component.html
// module id = ../../../../../src/app/shared/components/button/button.component.html
// module chunks = main